export default __webpack_public_path__ + "static/media/closet5-after2-2048w.7b1481cb.webp";